if (!Date.prototype.addDays) {
    Date.prototype.addDays = function (days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    };
}
if (!Array.prototype.forEach) {

    Array.prototype.forEach = function (callback/*, thisArg*/) {

        var T, k;
        if (this === null) {
            throw new TypeError('this is null or not defined');
        }
        var O = Object(this);
        var len = O.length >>> 0;
        if (typeof callback !== 'function') {
            throw new TypeError(callback + ' is not a function');
        }
        if (arguments.length > 1) {
            T = arguments[1];
        }
        k = 0;
        while (k < len) {
            var kValue;
            if (k in O) {
                kValue = O[k];
                callback.call(T, kValue, k, O);
            }
            k++;
        }
    };
}
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

function openUrl(url) {
    if (!url) return;
    if ((url.indexOf('http://') == 0 || url.indexOf('https://') == 0) && url.indexOf('globaloutdoors.com') == -1) window.open(url, '_blank');
    else
        window.location.href = url;
}

function onlyAllowIntegerKeys(evt) {    
    var charCode = evt.which ? evt.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57))
        return false;
    return true;
}


function onlyAllowTimeKeys(evt) {
    var charCode = evt.which ? evt.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && !(charCode === 65 || charCode === 97 || charCode === 80 || charCode === 112 || charCode===77 || charCode===109 || charCode ===58 || charCode===32))
        return false;
    return true;
}

function onlyAllowFloatKeys(evt) {
    var charCode = evt.which ? evt.which : event.keyCode;
    if (charCode > 31 && (charCode !== 46 && (charCode < 48 || charCode > 57)))
        return false;
    return true;
}


function isNullOrEmpty(s) {
    return s === '' || s === null;
}

function getGoogleEmbedUrl(experience) {    
    if (!experience || !experience.primaryAddress) return;
    var encodedAddress = '';
    if (experience.primaryAddress !== null && !isNullOrEmpty(experience.primaryAddress.city) && !isNullOrEmpty(experience.primaryAddress.street)) {
        encodedAddress = encodeURIComponent(experience.primaryAddress.street + ', ' + experience.primaryAddress.city + ', ' + experience.primaryAddress.stateName + ', ' + experience.primaryAddress.countryCode);

        //TODO: store key in config
        return 'https://www.google.com/maps/embed/v1/place?q=' + encodedAddress + '&key=AIzaSyAzUbdTePkb-ULsGC4kfubreFejEADGjMs';
    }
    else if (experience.primaryAddress !== null && !isNullOrEmpty(experience.primaryAddress.city) && isNullOrEmpty(experience.primaryAddress.street)) {
        encodedAddress = encodeURIComponent(experience.primaryAddress.fullAddress);

        //TODO: store key in config
        return 'https://www.google.com/maps/embed/v1/place?q=' + encodedAddress + '&key=AIzaSyAzUbdTePkb-ULsGC4kfubreFejEADGjMs';
    }
    else if (experience.primaryAddress !== null && experience.primaryAddress.latitude && experience.primaryAddress.longitude) {
        return 'https://www.google.com/maps/embed/v1/place?q=' + experience.primaryAddress.latitude + ',' + experience.primaryAddress.longitude + '&key=AIzaSyAzUbdTePkb-ULsGC4kfubreFejEADGjMs';
    } else {
        return 'https://www.google.com/maps/embed/v1/view?center=-33.8569,151.2152&zoom=0&key=AIzaSyAzUbdTePkb-ULsGC4kfubreFejEADGjMs';
    }
    
    
}
function getQueryStringParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
function parseQuery() {
    //TODO:Move this to global.
    var queryString = window.location.search;
    var query = {};
    var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=');
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
}

/**
 * IMG object-fit polyfill for IE
 * @link https://github.com/constancecchen/object-fit-polyfill
 */
!function () { "use strict"; if ("undefined" != typeof window) { var t = window.navigator.userAgent.match(/Edge\/(\d{2})\./), n = !!t && 16 <= parseInt(t[1], 10); if (!("objectFit" in document.documentElement.style != !1) || n) { var o = function (t, e, i) { var n, o, l, a, d; if ((i = i.split(" ")).length < 2 && (i[1] = i[0]), "x" === t) n = i[0], o = i[1], l = "left", a = "right", d = e.clientWidth; else { if ("y" !== t) return; n = i[1], o = i[0], l = "top", a = "bottom", d = e.clientHeight } if (n !== l && o !== l) { if (n !== a && o !== a) return "center" === n || "50%" === n ? (e.style[l] = "50%", void (e.style["margin-" + l] = d / -2 + "px")) : void (0 <= n.indexOf("%") ? (n = parseInt(n)) < 50 ? (e.style[l] = n + "%", e.style["margin-" + l] = d * (n / -100) + "px") : (n = 100 - n, e.style[a] = n + "%", e.style["margin-" + a] = d * (n / -100) + "px") : e.style[l] = n); e.style[a] = "0" } else e.style[l] = "0" }, l = function (t) { var e = t.dataset ? t.dataset.objectFit : t.getAttribute("data-object-fit"), i = t.dataset ? t.dataset.objectPosition : t.getAttribute("data-object-position"); e = e || "cover", i = i || "50% 50%"; var n = t.parentNode; return function (t) { var e = window.getComputedStyle(t, null), i = e.getPropertyValue("position"), n = e.getPropertyValue("overflow"), o = e.getPropertyValue("display"); i && "static" !== i || (t.style.position = "relative"), "hidden" !== n && (t.style.overflow = "hidden"), o && "inline" !== o || (t.style.display = "block"), 0 === t.clientHeight && (t.style.height = "100%"), -1 === t.className.indexOf("object-fit-polyfill") && (t.className = t.className + " object-fit-polyfill") }(n), function (t) { var e = window.getComputedStyle(t, null), i = { "max-width": "none", "max-height": "none", "min-width": "0px", "min-height": "0px", top: "auto", right: "auto", bottom: "auto", left: "auto", "margin-top": "0px", "margin-right": "0px", "margin-bottom": "0px", "margin-left": "0px" }; for (var n in i) e.getPropertyValue(n) !== i[n] && (t.style[n] = i[n]) }(t), t.style.position = "absolute", t.style.width = "auto", t.style.height = "auto", "scale-down" === e && (e = t.clientWidth < n.clientWidth && t.clientHeight < n.clientHeight ? "none" : "contain"), "none" === e ? (o("x", t, i), void o("y", t, i)) : "fill" === e ? (t.style.width = "100%", t.style.height = "100%", o("x", t, i), void o("y", t, i)) : (t.style.height = "100%", void ("cover" === e && t.clientWidth > n.clientWidth || "contain" === e && t.clientWidth < n.clientWidth ? (t.style.top = "0", t.style.marginTop = "0", o("x", t, i)) : (t.style.width = "100%", t.style.height = "auto", t.style.left = "0", t.style.marginLeft = "0", o("y", t, i)))) }, e = function (t) { if (void 0 === t || t instanceof Event) t = document.querySelectorAll("[data-object-fit]"); else if (t && t.nodeName) t = [t]; else { if ("object" != typeof t || !t.length || !t[0].nodeName) return !1; t = t } for (var e = 0; e < t.length; e++)if (t[e].nodeName) { var i = t[e].nodeName.toLowerCase(); if ("img" === i) { if (n) continue; t[e].complete ? l(t[e]) : t[e].addEventListener("load", function () { l(this) }) } else "video" === i ? 0 < t[e].readyState ? l(t[e]) : t[e].addEventListener("loadedmetadata", function () { l(this) }) : l(t[e]) } return !0 }; "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", e) : e(), window.addEventListener("resize", e), window.objectFitPolyfill = e } else window.objectFitPolyfill = function () { return !1 } } }();

$(document).ready(function () {
    //Add CSS to body if javascript is enabled

    if (document.body.classList) {
        document.body.classList.remove('javascript-disabled');
        document.body.classList.add('javascript-enabled');
    }

    toastr.options = {
        "positionClass": "toast-top-center"
    };

    //show utc times as local
    var showLocalTimes = document.getElementsByClassName('show-local-time');
    for (var i = 0; i < showLocalTimes.length; i++) {
        var element = showLocalTimes[i];
        var utc = element.dataset && element.dataset.utc;
        var date = new Date(utc);
        element.innerHTML = date.toLocaleDateString() + " " + date.toLocaleTimeString();
    }
    //show utc dates as local
    var showLocalDates = document.getElementsByClassName('show-local-date');
    for (var iShowLocalDate = 0; iShowLocalDate < showLocalDates.length; iShowLocalDate++) {
        var elementShowLocalDate = showLocalDates[iShowLocalDate];
        var utcShowLocalDate = elementShowLocalDate.dataset && elementShowLocalDate.dataset.utc;
        var dateShowLocalDate = new Date(utcShowLocalDate);
        elementShowLocalDate.innerHTML = dateShowLocalDate.toLocaleDateString();
    }

    //autogrow textareas marked with 'autogrow'
    var autogrows = document.getElementsByClassName('autogrow');
    for (var i2 = 0; i2 < autogrows.length; i2++) {
        var element2 = autogrows[i2];
        var autogrowElement = new Autogrow(element2);
        autogrowElement.autogrowFn(); //Move this to Autogrow?
    }

    //intercept 401s and redirect to login.  This mimics server-side behavior.
    if (axios) {
        axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
        axios.interceptors.response.use(null, function (error) {
            if ((error && error.response && error.response.status === 401)) {
                console.log('redirecting to login...');
                window.location.href = "/account/login?returnUrl=" + window.location.pathname;
            }
            return Promise.reject(error);
        });

        axios.get('/messages/unreadcount').then(function (res) {
            var element = document.getElementById('messagesCount');

            if (res.data && res.data.count > 0)
                element.innerHTML = ' <span class="indicator unread">&nbsp;</span>';
        });
    }




    // Simple scroll-to function
    $('.scroll-to').on('click', function (event) {
        var target = $(this).attr('href');
        if (target.length) {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: $(target).offset().top
            }, 1000);
        }
    });



    // Experience Gallery
    $('#experienceGallery').on('shown.bs.modal', function () {

        console.log('Bootstrap carousel loaded');

        $expGalleryCarousel = $('#experienceGalleryCarousel');
        $expGalleryCarouselInner = $('#experienceGalleryCarouselInner');
        $expGalleryCarouselIndicators = $('#experienceGalleryCarouselIndicators');
        $expGalleryItems = $expGalleryCarouselInner.find('.item');

        if ($expGalleryCarouselIndicators.is(':empty')) {

            $.when(
                $expGalleryItems.each(function (index, element) {
                    console.log(element);
                    //var activeClass = index === 0 ? ' active' : '';
                    var imgUrl = $(element).find('img').attr('src') || $(element).find('img').attr('data-src');
                    if (imgUrl) imgUrl = imgUrl.replace('w=1024', 'w=200').replace(/ /g, '%20');
                    console.log(imgUrl);
                    $expGalleryCarouselIndicators.append('<div class="exp-provider-carousel-tn"><div style="background-image: url(\'' + imgUrl + '\');"></div></div>');
                })
            ).then(
                $expGalleryCarouselInner.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    fade: true,
                    asNavFor: '#experienceGalleryCarouselIndicators'
                }),
                $expGalleryCarouselIndicators.slick({
                    slidesToShow: 9,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '30px',
                    focusOnSelect: true,
                    asNavFor: '#experienceGalleryCarouselInner',
                    responsive: [
                        {
                            breakpoint: 1280,
                            settings: {
                                arrows: false,
                                centerMode: true,
                                centerPadding: '40px',
                                slidesToShow: 7,
                                focusOnSelect: true,
                                asNavFor: '#experienceGalleryCarouselInner'
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                arrows: false,
                                centerMode: true,
                                centerPadding: '40px',
                                slidesToShow: 5,
                                focusOnSelect: true,
                                asNavFor: '#experienceGalleryCarouselInner'
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                arrows: false,
                                centerMode: true,
                                centerPadding: '20px',
                                slidesToShow: 3,
                                focusOnSelect: true,
                                asNavFor: '#experienceGalleryCarouselInner'
                            }
                        },
                        {
                            breakpoint: 360,
                            settings: {
                                arrows: false,
                                centerMode: true,
                                centerPadding: '50px',
                                slidesToShow: 1,
                                focusOnSelect: true,
                                asNavFor: '#experienceGalleryCarouselInner'
                            }
                        }
                    ]
                }),
                objectFitPolyfill()
            );


        }

    });


    //TODO: Do we need this?  Used in Ratings?
    //use ajax to post forms with class ajaxForm, and apply other conventions based on attributes
    if (FormData && axios) {
        var ajaxForms = document.getElementsByClassName('ajaxForm');
        for (var i3 = 0; i3 < ajaxForms.length; i3++) {
            var ajaxForm = ajaxForms[i3];

            ajaxForm.applyCss = function (className) {
                if (className && ajaxForm.classList) {
                    ajaxForm.addEventListener("animationend", function () { ajaxForm.classList.remove(className); }, false);
                    ajaxForm.classList.add(className);
                }
            };
            ajaxForm.ajaxSubmit = function () {
                //TODO: check for closure issue here...

                var ajaxFormData = new FormData(ajaxForm);
                var submittedByElement = window.event.target;
                axios.post(ajaxForm.action, ajaxFormData)
                    .then(function (response) {
                        if (ajaxForm.dataset) ajaxForm.applyCss(ajaxForm.dataset.successClass); //TODO: support other success/fail handlers
                    })
                    .catch(function (response) {
                        if (ajaxForm.dataset) ajaxForm.applyCss(ajaxForm.dataset.failClass); //TODO:shake css not working...
                    });
            };

            if (ajaxForm.elements) {
                var allElements = ajaxForm.elements;
                for (var i4 = 0; i4 < allElements.length; i4++) {
                    var element4 = allElements[i4];
                    if (ajaxForm.dataset) {
                        if (ajaxForm.dataset.submitOnchange) element4.addEventListener("change", function () { ajaxForm.ajaxSubmit(); });
                    }
                }

            }

        }
    }
});
